import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { Router } from '@angular/router';
import { LiquidacionService } from 'app/services/liquidacion/liquidacion.service';
import { LoginService } from 'app/services/login/login.service';
import Swal from "sweetalert2";
import { environment } from 'environments/environment';

declare var $: any;
@Component({
  selector: 'app-nuevo-resumen',
  templateUrl: './nuevo-resumen.component.html',
  styleUrls: ['./nuevo-resumen.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates]
})
export class NuevoResumenComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  loading:boolean = false;
  data: any = [];
  arraySend: any = [];
  user:any = [];
  flagAbrir:boolean = false;
  dataSource: any = [];

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  pageSizeOptions = [15,20,30,50,100,200];
  displayedColumns = ['Checked','Proveedor','Adquirente','Moneda','Cantidad','Adelanto_Importe','Pago_Importe','Estado'];

  constructor(
    private router:Router,
    private liquidacionService:LiquidacionService, 
    private loginService:LoginService) {
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
  }

  ngOnInit() {
    this.listadoLiquidacionesPorGrupo();
  }

  listadoLiquidacionesPorGrupo(){
    this.loading = true;
    this.liquidacionService.obtenerLiquidacionesPorGrupo().subscribe(
      res =>{
          this.data = res;
          this.data.map(object => object.checked = false);
          this.dataSource = new MatTableDataSource(this.data);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;  
      },err =>{
          Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false 
          });
          this.loading = false;
      }
    );
  }

  crearResumenLiquidacion(){
    console.log("arraySend",this.arraySend);
    if(this.arraySend.length>0){
      Swal.fire({
        title: 'Resumen de Liquidaciones',
        html: '¿Deseas generar <b>'+this.arraySend.length+'</b> resumen(es) de liquidación?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sí',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        heightAuto: false
      }).then((result) => {
        if (result.value) {
          this.agregarBody();
        }
      })
    } else {
        Swal.fire({
          title: 'Espera',
          text: 'Seleccione al menos una agrupación.',
          type: 'warning',
          heightAuto: false
        })
    }
  }
  agregarBody(){
    this.loading = true;
          this.loginService.clickGuard = true;
          let total = this.arraySend.length;
          let ini = 0;
          this.arraySend.forEach(element => {
            this.liquidacionService.crearLiquidacionResumen(element).subscribe(
              resp =>{
                this.showNotification('success','top','right','Resumen de liquidación generado satisfactoriamente.');
                ini++;
                if(ini == total) this.router.navigate(['/liquidacion/liquidaciones-resumen/listado']);
              },err => {
                let error = "";
                error = err.error.error;
                this.showNotification('warning','top','right','No se pudo generar el resumen de liquidaciones. \n Error: ' + error);
                ini++;
                if(ini == total) this.router.navigate(['/liquidacion/liquidaciones-resumen/listado']);
              }
            )
          })
         
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  limpiar(){
    if(this.arraySend.length == 0){
      this.arraySend = this.data;
      this.data.map(object => object.checked = true);
    } else {
      this.arraySend = [];
      this.data.map(object => object.checked = false);
    }
  }

  agregar(element: any){

    let array: any = {
      "identificador": 0,
      "idLiquidaciones": [],
      "usuario": this.user.Usuario,
      "canal": "W"
    };

    array.identificador = element.identificador;
    array.idLiquidaciones = element.idLiquidaciones.split(',').map(Number);

    if(element.checked){
      this.arraySend.push(array);
    } else {
      this.arraySend = this.arraySend.filter(function(dato){
        console.log("dato",dato);
        if (dato.identificador == array.identificador) {
          return false;
        } else {
          return true;
        }
      })
    }   
  }

  abrirPopUp(element){
    this.liquidacionService.arrayLiquidacionResumen = element;
    this.flagAbrir = true;
  }

  cerrarPopUP(){
    this.flagAbrir = false;
  }

  showNotification(type,from,align,message){
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}
